import {Component, OnInit} from '@angular/core';
import {ThemeService} from './core/theme.service';
import {TranslateService} from '@ngx-translate/core';
import * as Sentry from '@sentry/browser';
import {CommonService} from './services/common/common.service';
import {WebUtils} from './utils/web.utils';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'ACHOO';

  constructor(
    private theme: ThemeService,
    private commonService: CommonService,
    private translate: TranslateService) {

      this.translate.setDefaultLang('en');

      const lang = JSON.parse(localStorage.getItem('lang')) || 'en';
      this.translate.use(lang);
  }

  ngOnInit() {
    this.theme.initTheme();
    // clear previous UTM data
    this.commonService.clearUTMData();
    const utmSource = WebUtils.extractQueryParams('utm_source');
    const utmCampaign = WebUtils.extractQueryParams('utm_campaign');
    const utmMedium = WebUtils.extractQueryParams('utm_medium');
    this.commonService.storeUTMData(utmSource, utmCampaign, utmMedium);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts